'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearInstructors = exports.fetchInstructors = exports.fetchAdvertisers = undefined;
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _constants = require('../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var fetchAdvertisers = exports.fetchAdvertisers = function fetchAdvertisers(formId, product) {
  return {
    type: _constants.actionTypes.FETCH_ADVERTISERS,
    payload: _axios2.default.get(_constants.introducerUrls.advertiser, {
      params: {
        product: product
      }
    }).then(function (response) {
      var data = response.data.data;
      if (Array.isArray(data)) {
        window.dataLayer.push({
          event: 'aa_lookup',
          aa: {
            lookup_name: 'advertisers',
            lookup_result: 'success',
            error_message: ''
          }
        });
        return data.map(function (item) {
          return {
            captureExtraData: item.captureExtraData === '1',
            text: item.text,
            value: item.value
          };
        });
      }
      window.dataLayer.push({
        event: 'aa_lookup',
        aa: {
          lookup_name: 'advertisers',
          lookup_result: 'failure',
          error_message: 'not found'
        }
      });
      return [];
    }, function (error) {
      window.dataLayer.push({
        event: 'aa_lookup',
        aa: {
          lookup_name: 'advertisers',
          lookup_result: 'failure',
          error_message: error.message
        }
      });
      throw error;
    }),
    meta: {
      formId: formId
    }
  };
};
var fetchInstructors = exports.fetchInstructors = function fetchInstructors(formId, product, query) {
  return {
    type: _constants.actionTypes.FETCH_INSTRUCTORS,
    payload: _axios2.default.get(_constants.introducerUrls.instructor, {
      params: {
        product: product,
        query: query
      }
    }).then(function (response) {
      var data = response.data.data;
      if (Array.isArray(data)) {
        window.dataLayer.push({
          event: 'aa_lookup',
          aa: {
            lookup_name: 'instructors',
            lookup_result: 'success',
            error_message: ''
          }
        });
        return data;
      }
      window.dataLayer.push({
        event: 'aa_lookup',
        aa: {
          lookup_name: 'instructors',
          lookup_result: 'failure',
          error_message: 'not found'
        }
      });
      return [];
    }, function (error) {
      window.dataLayer.push({
        event: 'aa_lookup',
        aa: {
          lookup_name: 'instructors',
          lookup_result: 'failure',
          error_message: error.message
        }
      });
      throw error;
    }),
    meta: {
      formId: formId
    }
  };
};
var clearInstructors = exports.clearInstructors = function clearInstructors(formId) {
  return {
    type: _constants.actionTypes.CLEAR_INSTRUCTORS,
    formId: formId
  };
};